import {FieldValidationDto, HttpResponse, RequestParams, ValidationDto} from "../api"
import {makeAutoObservable} from "mobx"

class ValidationStore {

    get validation(): FieldValidationDto[] {
        return this._validation
    }

    set validation(value: FieldValidationDto[]) {
        this._validation = value
    }

    private _validation: FieldValidationDto[] = []
    private _abortController: AbortController | undefined

    constructor() {
        makeAutoObservable(this)
    }

    getFor(key: string): string | undefined {
        const errorDto = this.validation.filter(e => e.field === key)[0]
        return errorDto?.message
    }

    getErrorForDocuments(): FieldValidationDto[] | undefined {
        return this.validation.filter(e => e.field?.startsWith(`documents[`))
    }

    get valid(): boolean {
        return this.validation?.length === 0
    }

    async validate<T>(validationMethod: (data: T, params: RequestParams) => Promise<HttpResponse<ValidationDto, any>>, dto?: T) {
        if (dto && validationMethod) {
            try {
                if (this._abortController) {
                    this._abortController.abort()
                }
                this._abortController = new AbortController()
                const validationResponse = await validationMethod(dto, {
                    signal: this._abortController.signal
                })
                this.validation = validationResponse.data.fields || []
            } catch (e) {
            }
            return
        }
    }

    async validateOnEntity<T>(validationMethod: (id: string, data: T, params: RequestParams) => Promise<HttpResponse<ValidationDto, any>>, id: string, dto?: T) {
        if (dto && validationMethod) {
            try {
                if (this._abortController) {
                    this._abortController.abort()
                }
                this._abortController = new AbortController()
                const validationResponse = await validationMethod(id, dto, {
                    signal: this._abortController.signal
                })
                this.validation = validationResponse.data.fields || []
            } catch (e) {
            }
            return
        }
    }

    async validateWithQuery<T>(validationMethod: (
        data: T,
        query: any,
        params: RequestParams,
    ) => Promise<HttpResponse<ValidationDto, any>>, dto: T, query: any) {
        if (dto && validationMethod) {
            try {
                if (this._abortController) {
                    this._abortController.abort()
                }
                this._abortController = new AbortController()
                const validationResponse = await validationMethod(dto, query, {
                    signal: this._abortController.signal
                })
                this.validation = validationResponse.data.fields || []
            } catch (e) {
            }
            return
        }
    }

    reset() {
        if (this._abortController) {
            this._abortController.abort()
        }
        this._validation = []
    }
}

const validationStore = new ValidationStore()

export {
    validationStore
}
